import React from 'react';
import { Box, BoxProps } from '@common-fe/common-fe';

const HorizontalLine = (props: BoxProps) => (
  <Box height="1px" background="border1" margin={{ vertical: 'spacing24' }} {...props} />
);

export default HorizontalLine;
